import React, { Component } from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import './Watch.css';

import axios from 'axios';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-125267507-1');
ReactGA.pageview(window.location.pathname + window.location.search);

class Watch extends Component {

  constructor(props) {
    super(props);
    this.state = {
        videoUrl: '',
        journalNotes: '',
        areNotesCopied: false,
    };

    this.placeHolderPrompt = 'Use this space to jot down any insights that you have as you watch the video. It often helps to pause when you hear something juicy so that you can process what you heard and make sense of it within the context of your own life.';

    this.handleChange = this.handleChange.bind(this);
    this.handleJournalClick = this.handleJournalClick.bind(this);
    this.handleCopy = this.handleCopy.bind(this);
  }

  componentDidMount() {
      const self = this;
      axios.get(`https://search.myinnerwork.com/videos/video/${this.props.params.id}`).then(function(response) {
          self.setState({videoUrl: `https://youtube.com/embed/${self.props.params.id}`});
          // load video
      }).catch(function(error) {
          console.error(error);
          //don't load video
      })
  }

  handleJournalClick() {
    ReactGA.event({
      category: 'engagement',
      action: 'journal_clicked',
      label: 'Journal Text Area'
    });
  }

  handleCopy() {
    ReactGA.event({
      category: 'engagement',
      action: 'copied_to_clipboard',
      label: 'Copy Button'
    });
  }

  handleChange(event) {
    this.setState({journalNotes: event.target.value, areNotesCopied: false});
  }

    render() {
        return (
            <div className="flex-container">
              <div className="video">
                <iframe title="unique title" width="560" height="315" src={this.state.videoUrl} frameBorder="0"
                        allow="autoplay; encrypted-media" allowFullScreen></iframe>
              </div>
              <div className="journalNotes">
                <label className="journalLabel">
                  Space for Insights
                </label>
                <div>
                  <textarea onClick={this.handleJournalClick} className="journalArea" placeholder={this.placeHolderPrompt} cols="54" rows="6" value={this.state.journalNotes} onChange={this.handleChange} />
                </div>
                <CopyToClipboard text={this.state.journalNotes}
                                 onCopy={() => this.setState({areNotesCopied: true})}>
                  <button onClick={this.handleCopy}>Copy to clipboard</button>
                </CopyToClipboard>

                {this.state.areNotesCopied ? <span style={{color: '#40aea7', 'margin-left': '20px'}}>Copied.</span> : null}
              </div>
            </div>

        );
    }
}

export default Watch;



// WEBPACK FOOTER //
// ./src/components/Watch.js